import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin, map } from 'rxjs';
import { KmzService } from 'src/app/services/kmz.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as _ from "lodash";

@Component({
    selector: 'app-manage-kmz',
    templateUrl: './manage-KMZ.component.html',
    styleUrls: ['./manage-KMZ.component.scss']
})
export class ManageKMZComponent implements OnInit {
    manageKMZForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    filteredList1: any = []
    serviceQueue: any = []
    serviceProviderList: any = [];
    displayedColumns: string[] = [
        'check',
        'ProviderName',
        'ProviderAliasName',
        'ProductId',
        'Cost'
    ];
    Productkmzlist: any;
    data = [];
    dataSource = new MatTableDataSource(this.data);
    filteredList2: any;
    fileName: string;
    FileExtention: string;
    isFileSelected: boolean;
    kmlfilelist: any;
    selectedProducts: any = [];
    filteredList3: any;
    isPreviewChanges: boolean = false
    documents: any = []
    seletedfilepath: any;
    filteredProducts: any = []
    file: File;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild('searchInput') searchInput: ElementRef;
    sourceResponse: any = [];
    constructor(
        private fb: FormBuilder,
        private ProductService: ProductService,
        private lookupDataService: LookupDataServiceService,
        private toast: NotificationService,
        private KmzService: KmzService
    ) {
    }


    ngOnInit(): void {
        this.init()
        this.getTableData()
        this.initilizeStartUpServiceQueue()
        this.executeStartUpQueue()
    }
    init() {
        this.manageKMZForm = this.fb.group({
            serviceproviderId: [null, Validators.required],
            productClassification: [null, Validators.required],
            AttachmentFileName: [],
            KmzKmlOrExcel: [null, Validators.required],
            isExistingKmz: [false, Validators.required],
            kmlfiledetailsid: [null],
        });
    }
    ResetForm() {
        debugger
        this.manageKMZForm.reset()
        this.isFileSelected = false
        this.searchInput.nativeElement.value = null
        this.applyFilter(null)
    }
    initilizeStartUpServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getServiceProvider());
        this.serviceQueue.push(this.lookupDataService.getProductkmz());
    }

    executeStartUpQueue() {
        forkJoin(this.serviceQueue)
            .subscribe((serviceResponse) => {
                this.serviceProviderList = serviceResponse[0];
                this.filteredList1 = this.serviceProviderList.slice()
                this.Productkmzlist = serviceResponse[1];
                this.filteredList2 = this.Productkmzlist.slice()
            });
    }

    applyFilter(event: Event) {
        debugger
        const filterValue = (event?.target as HTMLInputElement)?.value.trim().toLowerCase();
        this.dataSource.filter = filterValue;

        this.dataSource.filteredData.forEach(datares => {
            const isExpired = datares.expiredOnTs === null;
            const matchesFilter = datares.productId.toLowerCase().includes(filterValue);
            if (isExpired && matchesFilter) {
                datares.isChecked = true;
            }
        });
        // this.dataSource = new MatTableDataSource(this.data);
        // this.dataSource.sort = this.sort;
        // this.dataSource.paginator = this.paginator;
    }

    selectFile() {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.style.display = 'none';
        document.body.appendChild(inputElement);
        inputElement.click();
        inputElement.addEventListener('change', async (event: any) => {
            debugger
            const files: FileList = (event.target as HTMLInputElement).files;
            if (!files || files.length == 0) {
                Swal.fire('Warning', 'Please upload file', 'warning');
                return;
            }

            if (!files || files.length > 2) {
                Swal.fire('Warning', 'Please one file at a time', 'warning');
                return;
            }

            this.fileName = files.item(0).name;
            this.file = files.item(0);
            var fileExtension = this.fileName.slice(
                this.fileName.lastIndexOf('.') + 1
            );
            var type =
                '|' + this.file.type.slice(this.file.type.lastIndexOf('/') + 1) + '|';
            var result =
                '|csv|xlsx|xls|kmz|kml|'.indexOf(type) !== -1 ||
                '|csv|xlsx|xls|kmz|kml|'.indexOf(fileExtension) !== -1;

            if (!result) {
                Swal.fire(
                    'Warning',
                    `Please upload a Correct File Format (csv, xlsx, xls)`,
                    'warning'
                );
                this.fileName = ' ';

                this.isFileSelected = false;
                return;
            }

            this.FileExtention = fileExtension;
            this.isFileSelected = true;
            // const singlefile: File = (event.target as HTMLInputElement).files[0];
            document.body.removeChild(inputElement);
            this.manageKMZForm.controls['AttachmentFileName'].setValue(this.fileName);

            let base64 = await this.convertToBase64(event.target.files[0]);
            const base64DataOnly = base64.split(',')[1];

            this.documents.push({
                'FileData': base64DataOnly,
                'fileName': this.file.name,
                'uploadedDate': moment().format('DD MMM YYYY hh:mm A'),
                'fileExtention': this.file.type,
                'fileType': this.file.type
            })
        });
    }
    convertToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    }

    reset() {
        const txt = 'Are you sure want to delete?';
        const Yes = 'Yes';
        const No = 'No';
        Swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.fileName = "";
                this.isFileSelected = false;
                this.manageKMZForm.controls['AttachmentFileName'].setValue(this.fileName);
            }
        });
    }
    selectedProvider() {
        debugger
        forkJoin([
            this.lookupDataService.getKMLFileDetails(this.manageKMZForm.value.serviceproviderId),
            this.lookupDataService.getProductsbyProvider(this.manageKMZForm.value.serviceproviderId)
        ]).subscribe((serviceResponse) => {
            this.kmlfilelist = serviceResponse[0];
            this.filteredList3 = this.kmlfilelist.slice();
            this.selectedProducts = serviceResponse[1];

            this.data.forEach(datares => {
                if (this.selectedProducts.some(selecres => selecres.value === datares.productId)) {
                    datares.isChecked = true;
                }
            });
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    select(product) {
        debugger
        product.isChecked = !product.isChecked;

    }
    save() {
        debugger;
        if (this.manageKMZForm.valid) {
            let payload: FormData = new FormData();
            const uniqueProducts = new Set();
            this.filteredProducts = [];

            this.dataSource.filteredData.forEach(res => {
                if (res.isChecked && !uniqueProducts.has(res.productId)) {
                    uniqueProducts.add(res.productId);
                    this.filteredProducts.push({ key: res.id, value: res.productId });
                }
            });

            const keys = this.filteredProducts.map(item => item.key);

            payload.append('ServiceProviderId', this.manageKMZForm.value.serviceproviderId);
            payload.append('MappedProductIds', keys);
            payload.append('IsExisting', this.manageKMZForm.value.isExistingKmz);
            payload.append('ExistingKMLLayerDetailsId', this.manageKMZForm.value.kmlfiledetailsid);
            payload.append('IsPreviewChanges', 'false');
            payload.append('ProductClassification', this.manageKMZForm.value.productClassification);
            payload.append('file', this.file);

            this.KmzService.saveKmzOrKml(payload).subscribe(res => {
                this.toast.showSuccess('Kmz/Kml has been uploaded successfully!');

                // Reset form after success
                this.ResetForm();
                debugger
                this.data = [...this.sourceResponse]
                this.dataSource = new MatTableDataSource(this.data);
            }, err => {
                this.toast.showError('An error occurred while saving the data.');
            });
        } else {
            // If the form is invalid, show an error message
            this.toast.showError('Please fill the required fields!');
            this.manageKMZForm.markAllAsTouched();
            return;
        }
    }


    previewChanges() {
        this.isPreviewChanges = true

        this.KmzService.previewChanges(this.documents).subscribe((res) => {

            var arealist = res.areaNameList;
            // var kmlUrl = environment.kmlFilePublicIpUrl + res.kmzOrKMLFileName;
            // modalService.previewKMZ("Preview KMZ/KML", kmlUrl, arealist);

        });
    }
    selectedkmlfile() {
        this.seletedfilepath = this.manageKMZForm.value.kmlfiledetailsid
    }

    getTableData() {
        // data = { searchQuery: data }
        this.ProductService.getAllProducts().pipe(
            map(result => {
                return result.map(item => ({ ...item, isChecked: false }));
            })
        ).subscribe((result) => {
            this.sourceResponse = result
            this.data = [];
            this.data = result;
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }



}
